const Lang =
{
        // Header
            Moon:"مون",
            MoonEgypt:"مون إيجيبت",
            Home: "الرئيسية",
            About: "عن الشركة",
            Services: "الخدمات",
            Projects: "المشاريع",
            ContactUs: "تواصل معنا",
            Lang: "عربي",
        //  footer
            Email:"الايميل : info@moonegypt.com" ,
            subscripUs:"اعرف كل جديد عنى",
            YourEmail:"بريدك الالكتروني",
            subscrip:"أشترك",
            copyrights:"جميع الحقوق محفوظة لدي مون إيجيبت",
        //  Home
            Design: "صمم",
            SomeThing: "شيئ",
            Gread: "عظيم!",
            Unique: "فريد!",
            And: "و",
            To: "إلى",
            Reach: "صل",
            SeeMore: "المزيد",
            osSoftwares: "انظمة مفتوحة المصدر",
            moonWord:"القمر",
            stages:"مراحل العمل",
            tools:"ادوات",
            idea:"فكرة",
            ideaDesc:"نركز علي فكرتك ونعطيك العديد من الخيارات",
            uxdesign:"تصميم مبدأي",
            uidesign:"تصميم تجربة المستخدم",
            surveys:"استبيانات",
            coding:"كتابة الكود",
            codingDesc:"بعد استكمال فكرتك نبدأ في تكويد المشروع الخاص بك باقل مشاكل وكود نظيف",
            html:"HTML",
            css:"CSS",
            javascript:"Javascript",
            php:"PHP",
            laravel:"Laravel",
            sql:"SQL",
            nodejs:"Nods.js",
            expressjs:"Express.js",
            testing:"الاختبار",
            testingDesc:"بعد الانتهاء من التكويد يتم اخبار المشروع من جميع الجوانب",
            unittesting:"اختبار الوحدات",
            integrationtesting:"اختبار التكامل",
            systemtesting:"اختبار النظام",
            acceptancetesting:"اختبار القبول",
            sitesweets:"حلوة المواقع",
            sitesweetsDesc:"في هذه المرحلة ، نركز على تحسين الاداء و محرك البحث والتكامل مع الأدوات التي يمكن أن توفر لك العديد من المخططات حول موقعك",
            marketplace:"متجري",
            searchconsole:"وحدة تحكم البحث",
            analytics:"احصائيات",
            ad:"اعلانات",
            lighthouse:"منارة تحسين الاداء",
            searchengines:"محركات البحث",
            metatags:"علامات البحث",
            cloudflare:"كلودفلير",
            deployment:"النشر",
            deploymentDesc:"نساعدك في نشر موقعك لعمل مرن وسهل",
            domain:"نطاق",
            hosting:"استضافة",
            ssl:"شهادة امان",
            gitandgithub:"git and github",
            emailaccounts:"بريد الاكتروني",
            ownSmtp:"مرسل بريد خاص",
        //  contactus
            TypeOfService:"نوع الخدمة",
            YourName:"أسمك",
            YourMessage:"رسالتك",
            submit:"أرسال",
            or:"أو",
        // saas product
            saasProduct:"SaaS منتج",
            saasProductDesc:"نساعدك في بناء منتج sass لربح المال دون اي تعب",
            SaaSProductStatistics:"أحصائيات منتجات saas",
            SaaSProductStatisticsdDesc:"عدد منتجات saas في عام ٢٠٢٢ حوالي ٢٥ الف",
            SaaSProductInCountries:"منتجات sass في جميع الدول",
            USA:"أمريكا",
            UK:"المملكة المتحدة",
            Canada:"كندا",
            Germany:"ألمانيا",
            France:"فرنسا",
            others:"أخري",
            k17:"١٧ الف",
            k2:"الفين",
            k1:"ألف",
            one:"١",
            two:"٢",
            three:"٣",
            four:"٤",
            five:"٥",
            six:"٦",
            howCanHelpYou:"كيف يمكننا مساعدتك؟",
            createYourIdea:"أنشاء فكرتك",
            makeYourProduct:"أنشاء مشروعك",
            integrationProduct:"ربط منتجك بادوات الاحصائيات",
            deploymentYourProduct:"نشر مشروعك علي القمر",
            welcomeInMoon:"مرحبك بك في القمر",
            ourProduct:"منتجاتنا",
            MoonForms:"نماذج مون",
        // wordpress
            Wordpress:"وردبريس",
            WordpressDesc:"نساعدك في بناء موقعك ومعها لوحة تحكم تستطيع بها التحكم بكل شيئ بموقعك دون الحاجه الي مطور بعد الان",
            WordpressStatistics:"أحصائيات وردبريس",
            WordpressStatisticsdDesc1:"١. عدد المواقع التي تستخدم وردبريس حوالي ٤٣.٢% (W3Techs, ٢٠٢٢)",
            WordpressStatisticsdDesc2:"٢. يزداد عدد مستخدمي وردبريس حوالي ١٢٪ منذ عام ٢٠١١ (W3Techs, ٢٠٢٢)",        
            WordpressAndOtherCMS:"وردبريس و مواقع ادارة المحتوي الاخرى",
            Wordpress:"وردبريس",
            Shopify:"شوبيفاي",
            Wix:"ويكس",
            Squarespace:"سكويرسبيس",
            Joomla:"جوملا",
            WordpressNum:"٦٥.٢٪",
            ShopifyNum:"٦.٦٪",
            WixNum:"٢.٨٪",
            squarespaceNum:"٢.٧٪",
            JoomlaNum:"٢.٦٪",
            makeYourWordpress:"‌بناء موقع الوردبريس الخاص بك بافضل مظهر و اضافات",
            MoonWordpress:"وردبريس مون",
            ///**************************** */ about **************************************//////
            smallCompany: ' مون إيجيبت هي شركة صغيرة نصنعها لمساعدة المبتدئين في الإنترنت لنشر نشاطهم حول العالم دون أي قيود',
            communitiesWithPeople: 'نحتاج إلى العديد من العملاء وننشئ مجتمعاتنا مع أشخاص من جميع أنحاء العالم',
            CreativeWebsite: 'أنشاء مواقع الكترونية خارج الصندوق لعملائنا',
            headquarters: 'ليس لشركتنا حاليًا مقر ثابت ، بل تمتلك نطاقًا معروفًا واستضافة على الإنترنت والبريد الإلكتروني الخاص بنا ، لأننا شركة فنية هدفها إنشاء خدمات الإنترنت ولا نحتاج حاليًا إلى مقر ثابت',
            vision: 'رؤية',
            note: "ملاحظة",
            policies: "سياسات",
            copyrightsPolicy: "سياسة حقوق التأليف والنشر",
            notToUseYourIdea : 'نلتزم بعدم استخدام فكرتك أو تصميمك في مشروع آخر بنفس الشكل واللون',
            codeDoesNotFallUnderCopyrightsRights : 'لا يندرج الكود ضمن حقوق سياسة حقوق التأليف والنشر ، لذا يمكن استخدامه مع مشاريع أخرى ، دون الإخلال بالنقطة السابقة',
            AcceptProjects : 'قبول سياسة المشاريع',
            SubjectToOurCapacity : 'نقبل عددًا محدودًا من المشاريع في كل مرة ، وفقًا لقدرتنا.',
            choosePreviousProject : 'لدينا الحق في اختيار ما إذا كان بإمكاننا تعديل مشروع سابق لم يتم إنشاؤه بواسطتنا ، وهذا يعتمد على بنية الكود لأنه في بعض الأحيان يستغرق تعديله وقتًا طويلاً ، وأحيانًا يكون بناء موقع آخر أفضل بكثير وأقل تكلفة .',
            ThePriority : 'الأولوية هي قبول المشاريع لعملائنا الحاليين أولاً ثم العملاء الجدد.',
            PricingPolicy: 'سياسة التسعير',
            effortAndTechnologies : 'نحدد سعر المشروع حسب ما نراه مناسبا من حيث الجهد والتقنيات التي سيتم استخدامها.',
            limitedNumberOfProjects : 'نقبل عددًا محدودًا من المشاريع في كل مرة ، وفقًا لقدرتنا.',
            projectIsLarge : 'عندما يكون المشروع كبيرًا ، يتم تقسيم الأموال إلى دفعات ، يتم دفعها مع الانتهاء من كل مرحلة.',
            discloseAnyPrices : "لا يجوز الإفصاح عن أي أسعار تم تحديدها معك ، وللشركة الحق في التوقف عن تنفيذ المشروع وتسليمه على حالته وقت إخلاء هذه النقطة." ,
            ProjectPolicy : 'سياسة المشروع',
            seriesOfMeetings : 'اقض الكثير من الوقت معك من خلال سلسلة من الاجتماعات لتشكيل فكرتك بشكل جيد ، وبناءً عليها سيتم الانتهاء من التصميم المتوقع للمشروع.',
            projectIsDivided : 'ينقسم المشروع إلى مراحل ، وفي كل مرحلة هناك اجتماع لشرح آخر التطورات ومعرفة رأيك قبل البدء بالمرحلة التالية.',
            ModernTechnologies : 'نستخدم التقنيات الحديثة ولا نعتمد على المشاريع القديمة بل يتم تحديث مشاريعنا أولاً',
            beforeStartingToWriteTheCode :'يتم الاتفاق على الشكل المتوقع لمشروعك قبل البدء في كتابة الكود ، ويتم التعامل على أساس هذا النموذج. ولكن إذا كان هناك تعديل على هذا النموذج بعد تصميمه. يحق للشركة طلب أموال إضافية لإجراء هذه التعديلات.',
            AfterSalePolicy : 'سياسة ما بعد البيع',
            trainingToManage : 'نوفر لك التدريب اللازم لإدارة مشروعك دون الحاجة لذلك.',
            encryptAnyData : 'نقوم بتسليم مشروعك بالكامل دون إخفاء أي شيء أو تشفير أي بيانات.',
            completingYourProject : 'تلتزم الشركة بتنفيذ مشروعك ، لكننا غير مسئولين عن أي إجراء تقوم به على موقعك بعد الانتهاء من مشروعك وتسليمه لك ، فهو ملك لك وأنت مسؤول عنه.', 
            threeParts : 'أي موقع يحتوي على ثلاثة أجزاء.',
            beautifulDesign : 'نحن نركز على التصميم الجميل وأفضل تجربة للمستخدم.',
            saveData : 'نحن نركز على كيفية حفظ البيانات وإرسال رسائل البريد الإلكتروني وإنشاء لوحة تحكم لتعديل موقعك.',
            union : 'نحن نركز على اتحاد الأشخاص والعمليات والتكنولوجيا لتقديم قيمة للعملاء باستمرار.',
            /************************ porject  ******************* */
            seeOurProjects : 'شاهد مشاريعنا ومشاريع عملائنا.',
            More : 'أكثر',
            ecommerce: 'متجر الكتروني',
            ecommerceLink: 'https://moda.moonegypt.com/ar',
            demo:'نسخة تجريبية',
            cms: 'نظام ادارة محتوي',
            website: 'موقع الكتروني',

} 


export default Lang;
